import styled from '@emotion/styled';
import { SmallText } from 'ds/components/typography';

export const CompareButton = styled(SmallText)`
  display: flex;
  height: 32px;
  padding: 8px 12px;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  background: rgba(1, 132, 137, 0.05);
  color: ${({ theme }) => theme.colors.brand.main};
  cursor: pointer;
`;

export const Wrapper = styled.div`
  ${({ theme }) => theme.media.showAt({ from: 3 })`
    width: 398px;
    border-radius: 8px;
    background: ${theme.colors.neutrals.white};
    box-shadow: ${theme.shadow.level7};
  `}
`;

export const ListWrapper = styled.div`
  ${({ theme }) => theme.media.showAt({ from: 3 })`
    padding: ${theme.spacing(3)} ${theme.spacing(3)} ${theme.spacing(4)};
  `}
  ${({ theme }) => theme.media.showAt({ to: 2 })`
    padding: ${theme.spacing(3)} 0 ${theme.spacing(4)};
  `}
`;

export const Title = styled.div`
  color: ${({ theme }) => theme.colors.neutrals.grey1};
  font-size: 17px;
  font-weight: 700;
  line-height: 22px;
  padding-bottom: ${({ theme }) => theme.spacing(1.75)};
`;

export const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(1)};
`;

export const Buttons = styled.div`
  ${({ theme }) => theme.media.showAt({ from: 3 })`
    padding: ${theme.spacing(1.25)};
    border-top: 1px solid ${theme.colors.neutrals.grey8};
    text-align: left;
  `}
  ${({ theme }) => theme.media.showAt({ to: 2 })`
    padding-top: ${theme.spacing(2)};
  `}
`;

export const ItemWrapper = styled.div<{ isDisabled: boolean }>`
  display: flex;
  padding: ${({ theme }) => theme.spacing(1)};
  gap: 10px;
  border-radius: ${({ theme }) => theme.borderRadius.large};
  border: 1px solid ${({ theme }) => theme.colors.neutrals.grey8};
  background: ${({ theme }) => theme.colors.neutrals.white};
  align-items: center;
  cursor: ${({ isDisabled }) =>  isDisabled ? 'not-allowed' : 'pointer'};
  opacity: ${({ isDisabled }) =>  isDisabled ? 0.5 : 1};
  pointer-events: ${({ isDisabled }) =>  isDisabled ? 'none' : 'all'};
`;

export const InfoWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1)};
`;

export const IconWrapper = styled.div`
  display: flex;
  width: 48px;
  height: 48px;
  justify-content: center;
  align-items: center;
  border-radius: 12px;
  background: ${({ theme }) => theme.colors.neutrals.grey10};
`;

export const Info = styled.div`
  display: flex;
  flex-direction: column;
  color: ${({ theme }) => theme.colors.neutrals.grey1};
`;

export const StickyWrapper = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: ${({ theme }) => theme.colors.neutrals.white};
  color: ${({ theme }) => theme.colors.neutrals.grey1};
  z-index: 1000;
  box-shadow: 0px -1px 8px 0px rgba(0, 0, 0, 0.10);
  height: 64px;
  display: flex;
  padding: 0 ${({ theme }) => theme.spacing(4)};
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1)};
`;

export const CompareIconWrapper = styled.div`
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: ${({ theme }) => theme.borderRadius.round};
  background-color: ${({ theme }) => theme.colors.brand.main};
  & svg {
    path {
      stroke: ${({ theme }) => theme.colors.neutrals.white};
    }
  }
`;

export const TextArea = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Subtitle = styled.div`
  color: ${({ theme }) => theme.colors.brand.main};
  text-align: right;
  font-size: 11px;
  line-height: normal;
`;

export const MainText = styled.div`
  color: ${({ theme }) => theme.colors.brand.main};
  text-align: right;
  font-size: 15px;
  font-weight: 700;
  line-height: normal;
`;
